<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> تغییر آدرس </span>

    </div>

</div>

<div dir="rtl" class="form w-100 row gx-2 px-2">

    <div class="col-12 col-md-3">

        <label> نام مدرسه </label>

        <input type="search" class="form-control" [(ngModel)]="searchT_School" (input)="filterSchool()" />

        <ul class="list-group" style="max-height: 200px;overflow: auto;">

            <li class="list-group-item pointer" *ngFor="let item of filteredSchools" (click)="getStudent(item)"
                [@fadeAnimation]>{{ item.strComment }} </li>

        </ul>

    </div>

    <div class="col-12 col-md-3">

        <label> نام دانش آموز </label>

        <input type="search" class="form-control" [(ngModel)]="searchT_Student" (input)="filterStudent()" />

        <ul class="list-group" style="max-height: 200px;overflow: auto;">

            <li class="list-group-item pointer" *ngFor="let item of filteredStudents" [@fadeAnimation]
                (click)="onStudent_selected(item)">{{item.strPassenger_FullName }} </li>

        </ul>

    </div>

    <div class="col-12 col-md-2">

        <form [formGroup]="dateFilter">

            <label> از تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input dir="ltr" type="text" formControlName="fromDate" class="form-control " />

            </ng-persian-datepicker>

        </form>

    </div>

    <div class="col-12 col-md-2">

        <form [formGroup]="dateFilter">

            <label> تا تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input dir="ltr" type="text" formControlName="toDate" class="form-control " />

            </ng-persian-datepicker>

        </form>

    </div>

    <div class="col-12 col-md-2 mt-2 mt-md-0 d-flex align-items-end  justify-content-end ">

        <button class="btn mx-md-2 px-5 btn-primary w-100 " type="button" (click)="search_student()">جستجو</button>

    </div>

</div>

<main class=" rtl px-2 mt-2 p-2">

    <div class="col-12 d-flex flex-column flex-md-row align-items-center justify-content-between">

        <span class="col-12 col-md-6 px-2" *ngIf="list_address.length > 0"> تعداد <span
                class="text-danger fw-bold ">{{list_address.length | faNum}}</span> مورد یافت شد </span>

        <div *ngIf="list_address.length > 0" class="col-12 col-md-6 text-end">

            <button class="btn btn-danger" (click)="message_Modal()">

                <span> ارسال پیام </span>

                <i class="fa fa-envelope mx-2" aria-hidden="true"></i>

            </button>

        </div>

    </div>

    <div class="mt-2 border border-2 p-2">

        <div class="table-responsive" style="max-height: 70vh;">

            <table class="table table-striped" id="Export_Excel">

                <thead class="position-sticky top-0 bg-white">

                    <tr class="col-12 text-center">

                        <th> # </th>

                        <th> عملیات </th>

                        <th (click)="selectAllCheckBox()" class="pointer">انتخاب</th>

                        <th> تاریخ </th>

                        <th> نام و نام خانوادگی </th>

                        <th> مدرسه </th>

                        <th> وضعیت </th>
                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of list_address;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td class="col-1">

                            <i class="fa fa-map-marker fa-lg px-3 btn btn-primary" title="موقعیت"
                                (click)="showOnMap(item.fOriginLon, item.fOrigiLat)"></i>

                            <i class="fa fa-info-circle fa-lg my-2 mx-2 btn btn-dark" title="جرئیات"
                                (click)="showDetail(item)"></i>

                        </td>

                        <td><input type="checkbox" (change)="setCheckBox($event.target.checked,item)"
                                [checked]="isSelected(item.iPassenger)"></td>

                        <td>{{item.strDate | faNum}}</td>

                        <td>{{item.strPassenger_FullName}}</td>

                        <td>{{item.strMobileDomain_strComment}}</td>

                        <td>{{item.strStatus}}</td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<div class="modal fade" id="detailModal" tabindex="-1" aria-labelledby="" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> ویرایش آدرس </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="text-center ">

                <img class="x rounded-circle" width="150" height="150"
                    src="{{studentData?.strAvatar != '' ? 'data:image/jpeg;base64,' +  studentData?.strAvatar : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}"
                    alt="">

            </div>

            <form #changeAddress="ngForm" (ngSubmit)="saveAddress(changeAddress)" dir="rtl" class="row p-2 gx-2 gy-2">

                <div class="col-6">

                    <label> نام و نام خانوادگی </label>

                    <input type="text" [ngModel]="studentData?.strName + ' ' + studentData?.strFamily"
                        name="strFullName" class="x form-control">

                </div>

                <div class="col-6">

                    <label> مدرسه </label>

                    <input type="text" [ngModel]="studentData?.strMobileDomain_strComment"
                        name="strMobileDomain_strComment" class="x form-control">

                </div>

                <div class="col-12 position-relative">

                    <label for="strAddress">آدرس</label>

                    <input [ngModel]="studentData?.strAddress" name="strAddress" class="x form-control col-md-10 py-2">

                    <button class="mx-2 btn btn-warning location-button rounded position-absolute" type="button"
                        (click)="showOnMap(studentData.fOriginLon, studentData.fOrigiLat)">

                        <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                    </button>

                </div>

                <div class="col-12 position-relative" *ngIf="studentData?.strAddress_Pickup != ''">

                    <label for="strAddress"> آدرس مبدا </label>

                    <input [ngModel]="studentData?.strAddress_Pickup" name="strAddress_Pickup"
                        class="x form-control col-md-10 py-2">

                    <button class="mx-2 btn btn-warning location-button rounded position-absolute" type="button"
                        (click)="showOnMap(studentData.fPickup_Lon, studentData.fPickup_Lat)">

                        <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                    </button>

                </div>

                <div class="col-12 position-relative" *ngIf="studentData?.strAddress_GettOff != ''">

                    <label for="strAddress"> آدرس مقصد </label>

                    <input [ngModel]="studentData?.strAddress_GettOff" name="strAddress_GettOff"
                        class="x form-control col-md-10 py-2">

                    <button class="mx-2 btn btn-warning location-button rounded position-absolute" type="button"
                        (click)="showOnMap(studentData.fGetOff_Lon, studentData.fGetOff_Lat)">

                        <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                    </button>

                </div>

                <div class="col-12 col-md-6">

                    <label> هزینه </label>

                    <input [disabled]="studentData?.tiStatus == 3" type="text"
                        [ngModel]="( studentData?.iCost | faNum ) + ' ریال' "
                        oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')  + ' ریال' "
                        name="iCost" class="form-control">

                </div>

                <div class="col-12 col-md-6">

                    <label> وضعیت </label>

                    <select class="form-control" [ngModel]="studentData?.tiStatus"
                        [disabled]="studentData?.tiStatus == 3" name="tiStatus">

                        <option value="0"> انتخاب کنید </option>

                        <option value="1"> تایید </option>

                        <option value="2"> عدم تایید </option>

                        <option value="3" *ngIf="studentData?.tiStatus == 3"> این درخواست لغو شده است </option>

                    </select>

                </div>

                <div class="col-12">

                    <textarea [ngModel]="studentData?.strComment" [disabled]="studentData?.tiStatus == 3"
                        placeholder="توضیحات" name="strComment" class="form-control" cols="30" rows="7"></textarea>

                </div>

                <div class="col-12 d-flex justify-content-end" *ngIf="studentData?.tiStatus != 3">

                    <button class="btn px-5 btn-primary " type="submit"> ویرایش </button>

                </div>

            </form>

        </div>

    </div>

</div>

<div class="modal fade" id="stdLocation" style="z-index: 100000000000000;" tabindex="-1" aria-labelledby=""
    aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> موقعیت</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div id="map" class="position-sticky w-100 " style="height: 500px;">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="sendMessage" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false"
    data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <form #message="ngForm" (ngSubmit)="sendMessage(message)" class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> ارسال پیامک </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div dir="rtl" class=" col-12 mb-2 p-2 mt-">

                <textarea dir="rtl" ngModel name="strMessage" class="form-control mb-2" cols="20" rows="7"
                    placeholder="پیام خود را وارد کنید"></textarea>

                <div class="col-12 col-md-6">

                    <input dir="rtl" type="checkbox" [ngModel]="false" name="bSendPush" class="mt-2"> ارسال پیام درون
                    برنامه ای

                </div>

                <div class="col-12 col-md-6">

                    <input dir="rtl" type="checkbox" [ngModel]="false" name="bSaveMessage" class="mt-2"> ثبت پیام
                    در
                    کارتابل

                </div>


            </div>

            <div class="mb-2">

                <button class="btn mx-2 px-5 btn-primary" type="submit"> ارسال </button>

            </div>

        </form>

    </div>
</div>

<ng-container *ngIf="isLoading" class="">

    <div class="school_loading">

        <img src="../../../../assets/Img/school_2.gif" alt="loading">

    </div>

</ng-container>